'use client';

import { Table as HeroUiTable, type TableProps } from '@heroui/table';
import { forwardRef } from 'react';

export const Table = forwardRef<HTMLTableElement, TableProps>((props, ref) => (
  <HeroUiTable
    ref={ref}
    radius="none"
    classNames={{ wrapper: 'shadow-none rounded-2xl' }}
    {...props}
  />
));
Table.displayName = 'Table';
